//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Description from '@/components/toast/description'

export default {
    name: "",
    data(){
        return {

        }
    },
    props:{
      templateFlag:{
        type: String,
        default() { return ''}
      },
      detailInfo:{
        type:Object,
        default (){ return {} }
      },
    },
    components:{
      Description
    },
    methods: {
       descrClick(){
            this.$refs.descr.showoast();
        },
    }
}
